var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { OverflowMenu } from './OverflowMenu';
import { Spinner } from './Spinner';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useThemeStyle } from '../hooks/useThemeStyle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
export var FatRow = createOverridableComponent('div', function (_a, Wrapper, ref) {
    var title = _a.title, meta = _a.meta, actions = _a.actions, right = _a.right, left = _a.left, busy = _a.busy, checked = _a.checked, children = _a.children, multiCheck = _a.multiCheck, props = __rest(_a, ["title", "meta", "actions", "right", "left", "busy", "checked", "children", "multiCheck"]);
    var css = useThemeStyle('fatRow', {
        display: 'flex',
        flexDirection: ['column', 'row'],
        alignItems: ['stretch', 'center'],
        mx: 2,
    });
    return (jsx(Wrapper, __assign({}, props, { css: css, ref: ref }),
        jsx("div", { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flex: 1,
            } },
            checked !== undefined && (jsx("div", { sx: { mr: 3 } },
                jsx(FontAwesomeIcon, { icon: checked ? faCheckCircle : multiCheck ? faPlus : faCheck, sx: { color: checked ? 'info' : 'grey' } }))),
            left && jsx("div", { sx: { mr: 3 } }, left),
            jsx("div", null,
                jsx("div", { className: "title" }, title),
                meta && jsx("div", { sx: { color: 'muted', fontSize: 1 } }, meta))),
        children,
        (busy || right || actions) && (jsx("div", { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            } },
            busy && (jsx("div", { sx: { mr: 3, color: 'primary' } },
                jsx(Spinner, null))),
            right && (jsx("div", { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexGrow: 1,
                } }, right)),
            actions && (jsx("div", { sx: { ml: ['auto', undefined], pl: 2 } },
                jsx(OverflowMenu, null, actions)))))));
});
//# sourceMappingURL=FatRow.js.map